// extracted by mini-css-extract-plugin
export default {"start":"DoneScreen_start__esmQb","startButton":"DoneScreen_startButton__gmNre","startHint":"DoneScreen_startHint__X3kF4","previewLabel":"DoneScreen_previewLabel__dvkJ1"};